"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonWithOpts = void 0;
const react_1 = __importDefault(require("react"));
const icon_1 = require("../icon");
require("../button/style.scss");
require("../dropdown/style.scss");
const classnames_1 = __importDefault(require("classnames"));
const util_1 = require("@app/util");
const ButtonWithOpts = ({ size = 'MEDIUM', htmlType = 'BUTTON', style = 'OUTLINED', color = 'PRIMARY', tabIndex = 1, disabled = false, onClickActiveWhenDisabled = false, loading = false, label = '', onClick, children, ico, bold, onContextMenu, testid, options, onChange }) => {
    const floatable = (0, util_1.useFloatable)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: { minWidth: '7.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '2.125rem' }, ...floatable.floatAnchor, onClick: undefined },
            react_1.default.createElement("button", { tabIndex: tabIndex, "data-testid": testid, onClick: ((!disabled || onClickActiveWhenDisabled) && !loading) ? onClick : undefined, onContextMenu: onContextMenu, type: htmlType === 'SUBMIT' ? 'submit' : 'button', className: (0, classnames_1.default)('ds-button', size?.toLowerCase(), style?.toLowerCase(), color?.toLowerCase(), {
                    'with-ico': ico ?? loading,
                    'only-ico': !label && !children,
                    bold,
                    disabled,
                    loading,
                }), style: (0, util_1.isDefined)(options) ? { minWidth: '5.5rem', height: '100%', borderTopRightRadius: 0, borderBottomRightRadius: 0 } : { width: '100%' } },
                !loading && ico && (react_1.default.createElement("div", { className: 'icon' },
                    react_1.default.createElement(icon_1.Icon, { ico: ico, size: icon_1.Icon.SIZES.SMALL }))),
                (loading && (react_1.default.createElement("div", { className: 'spinner' },
                    react_1.default.createElement("div", { className: 'spinning' },
                        react_1.default.createElement(icon_1.Icon, { ico: icon_1.Icon.ICONS.loader, size: icon_1.Icon.SIZES.SMALL }))))),
                label || children),
            (0, util_1.isDefined)(options) && (react_1.default.createElement("div", { className: (0, classnames_1.default)('ds-button', size?.toLowerCase(), style?.toLowerCase(), color?.toLowerCase(), {
                    disabled,
                    loading,
                }), style: {
                    width: '2rem',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: 0,
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0
                }, "data-testid": (0, util_1.isDefined)(testid) ? `${testid}-options` : undefined, onClick: () => {
                    if (disabled || loading) {
                        return;
                    }
                    floatable.setOpen(!floatable.open);
                } },
                react_1.default.createElement(icon_1.Icon, { ico: 'arrow-down', size: 'small' }))),
            floatable.open && (0, util_1.isDefined)(options) &&
                react_1.default.createElement("div", { className: 'ds-dropdown-new' },
                    react_1.default.createElement("div", { ref: floatable.floatContainer.ref, className: 'dropdown-options', style: { ...floatable.floatContainer.style, minWidth: 'max-content', maxWidth: '100%' } }, options.map((option, index) => (react_1.default.createElement(react_1.default.Fragment, { key: `${option.value?.toString()}-${index}` },
                        react_1.default.createElement("div", { onClick: () => {
                                floatable.setOpen(false);
                                onChange?.(option);
                            }, className: (0, classnames_1.default)('option-item', {
                                'is-selected': options.some((item) => item.value === option.value),
                                'with-title': !!option.groupTitle,
                            }) },
                            react_1.default.createElement("div", { className: 'option-value' }, option.label))))))))));
};
exports.ButtonWithOpts = ButtonWithOpts;
